import styled from 'styled-components';
import { COLORS } from './colors';

export const H1 = styled.h1`
  font-size: 64px;
  font-weight: 700;
  color: ${COLORS.textPrimary};
  line-height: 1.2;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 38px;
  }
`;

export const H2 = styled.h2`
  font-size: 36px;
  font-weight: 600;
  color: ${COLORS.textPrimary};

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Paragraph = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${COLORS.textPrimary};
  line-height: 1.6;
`;

export const Highlight = styled.span`
  color: ${COLORS.primary};
  font-weight: 700;
`;

export const ButtonText = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.buttonText};
`;

export const SubHeading = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${COLORS.primary};
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const ParagraphLg = styled(Paragraph)`
  font-size: 1.6rem;
  line-height: 1.8;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Divider = styled.div`
  width: 64px;
  height: 4px;
  background-color: ${COLORS.primary};
  margin-bottom: 16px;
  border-radius: 2px;
`;